import { SignalKey, WebpageWithRisk } from './types';

export interface SignalDef {
  key: SignalKey;
  label: string;
  predicate: (wp: WebpageWithRisk) => boolean;
}

/**
 * The single source of truth for the five webpage signals. Used by BOTH the
 * filter toggle chips and the leaf-row signal icons so the "does this page have
 * signal X" logic lives in exactly one place.
 */
export const SIGNAL_DEFS: SignalDef[] = [
  {
    key: 'secrets',
    label: 'Secrets',
    predicate: wp => Boolean(wp.risk?.name?.startsWith('web-secret-')),
  },
  {
    key: 'login',
    label: 'Login',
    predicate: wp => wp.type === 'authentication',
  },
  {
    key: 'sso',
    label: 'SSO',
    predicate: wp => Object.keys(wp.sso_identified || {}).length > 0,
  },
  {
    key: 'screenshots',
    label: 'Screenshots',
    predicate: wp => Boolean(wp.screenshot),
  },
  {
    key: 'response',
    label: 'Response',
    predicate: wp => Boolean(wp.details_filepath),
  },
];

/**
 * A webpage passes only if it satisfies EVERY active signal (AND combine),
 * mirroring the Assets table's cross-dimension filter behavior. An empty
 * active set matches everything.
 */
export function matchesAllSignals(
  wp: WebpageWithRisk,
  active: Set<SignalKey>
): boolean {
  return SIGNAL_DEFS.every(def => !active.has(def.key) || def.predicate(wp));
}
